import { useQuery } from '@tanstack/react-query';

import {
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useGetPrototypeAccessConfigQuery = (
  prototypeId: string,
  type: 'report' | 'testing'
) => {
  const { prototypePasswordManagement } = useAvApi();

  return useQuery({
    enabled: !!prototypeId,
    queryKey: ['prototype-access-config', prototypeId, type],
    queryFn: async () => {
      if (!prototypeId) return null;

      const { data } =
        await prototypePasswordManagement.getV2PrototypesPasswordAccessByPrototypeIdAndType(
          {
            prototypeId,
            type,
          }
        );

      return data;
    },
  });
};
